if (!customElements.get('hovermist-product')) {
  customElements.define('hovermist-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        window.addEventListener('scroll', this.scrollHandler, { passive: true });
        this.scrollHandler();
        return;
      }
      this.initialized = true;
      this.thumbnails = [...this.querySelectorAll('[data-gallery-src]')];
      this.imageIndex = 0;
      this.thumbnails.forEach((button, index) => button.addEventListener('click', () => this.showImage(index)));
      this.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => this.showImage(this.imageIndex + Number(button.dataset.galleryStep))));
      this.querySelectorAll('input[name="quantity"]').forEach(input => input.addEventListener('change', () => this.updatePrices()));
      this.querySelector('[data-variant]')?.addEventListener('change', () => this.updateVariant());
      this.sticky = this.querySelector('[data-sticky-buy]');
      this.purchase = this.querySelector('.hm-purchase-form');
      this.scrollHandler = () => {
        if (this.sticky && this.purchase) this.sticky.hidden = this.purchase.getBoundingClientRect().bottom > 0;
      };
      window.addEventListener('scroll', this.scrollHandler, { passive: true });
      this.scrollHandler();
    }
    disconnectedCallback() { window.removeEventListener('scroll', this.scrollHandler); }
    showImage(index) {
      this.imageIndex = (index + this.thumbnails.length) % this.thumbnails.length;
      const selected = this.thumbnails[this.imageIndex];
      const image = this.querySelector('[data-gallery-image]');
      image.src = selected.dataset.gallerySrc;
      image.alt = selected.dataset.galleryAlt;
      image.style.objectFit = selected.dataset.galleryFit;
      this.thumbnails.forEach((button, i) => button.setAttribute('aria-pressed', String(i === this.imageIndex)));
      this.querySelector('[data-image-counter]').textContent = `${this.imageIndex + 1} / ${this.thumbnails.length}`;
    }
    money(cents) { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'EUR' }).format(cents / 100); }
    updatePrices() {
      const price = Number(this.dataset.price);
      const quantity = Number(this.querySelector('input[name="quantity"]:checked')?.value || 1);
      this.querySelectorAll('[data-unit-price]').forEach(element => { element.textContent = this.money(price); });
      this.querySelectorAll('[data-quantity-price]').forEach(element => { element.textContent = this.money(price * Number(element.dataset.quantityPrice)); });
      this.querySelector('[data-total-price]').textContent = this.money(price * quantity);
      this.querySelector('[data-sticky-title]').textContent = quantity > 1 ? `HoverMist Roadster × ${quantity}` : 'HoverMist Roadster';
    }
    updateVariant() {
      const option = this.querySelector('[data-variant]').selectedOptions[0];
      this.dataset.price = option.dataset.price;
      const available = option.dataset.available === 'true';
      this.querySelectorAll('[data-buy]').forEach(button => { button.disabled = !available; });
      this.querySelectorAll('[data-buy-label]').forEach(label => { label.textContent = available ? 'PRE-ORDER NOW' : 'CURRENTLY UNAVAILABLE'; });
      this.updatePrices();
    }
  });
}
